import React from "react";

export default ({ height }) => {
  return <div className="popup-vertical-spacer" style={{ height }} />;
};
